import React from 'react';
import { useCommands } from '@remirror/react';
import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  useColorModeValue,
  VStack,
} from '@cardboard-ui/react';
import {
  AlignCenterIcon,
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignRightIcon,
  DropdownIcon,
} from 'components/icons';
import { t } from '@lingui/macro';
import { FloatingToolbarMenuItem } from './FloatingToolbarMenuItem';

export function AlignTools() {
  const commands = useCommands();

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label={t`Align`}
        icon={
          <Box marginLeft={2}>
            <AlignLeftIcon />
            <DropdownIcon />
          </Box>
        }
        size="xs"
        colorScheme="gray"
        variant="ghost"
      />
      <MenuList
        shadow="lg"
        py="4"
        color={useColorModeValue('gray.600', 'gray.200')}
        px="3"
        minW="auto"
      >
        <VStack align="flex-start">
          <FloatingToolbarMenuItem
            title={t`Left align`}
            icon={<AlignLeftIcon />}
            onClick={() => commands.leftAlign()}
          />
          <FloatingToolbarMenuItem
            title={t`Centre align`}
            icon={<AlignCenterIcon />}
            onClick={() => commands.centerAlign()}
          />
          <FloatingToolbarMenuItem
            title={t`Right align`}
            icon={<AlignRightIcon />}
            onClick={() => commands.rightAlign()}
          />
          <FloatingToolbarMenuItem
            title={t`Justify`}
            icon={<AlignJustifyIcon />}
            onClick={() => commands.justifyAlign()}
          />
        </VStack>
      </MenuList>
    </Menu>
  );
}
